let scalePointInfos = document.querySelectorAll('.scale-point-info');
const scalePointWrapper = document.querySelector('.side-panel-scale-point');
const scalePointTextarea = document.querySelector('input.scale-point-text-area');

function scalePointInfo() {
  scalePointInfos.forEach(scalePointInfo => {
    if (!scalePointInfo) return;
    let scalePointInfoText = scalePointInfo.querySelector('.scale-point-info-text');
    if (scalePointInfoText) {
      if (window.matchMedia('screen and (max-width: 767px)')) {
        scalePointInfo.addEventListener('click', function (e) {
          e.preventDefault();
          if(!scalePointInfo) return;
          
          if (scalePointInfoText.style.visibility == 'hidden') {
            scalePointInfoText.style.visibility = 'visible';
          } else {
            scalePointInfoText.style.visibility = 'hidden';
          }
        });
      }
    }
  })
}


function scalePointInputOnChange() {
  const scalePointWrapperUpdated = document.querySelector('.side-panel-scale-point');
  const scalePointTextareaUpdated = scalePointWrapperUpdated.querySelector('input.scale-point-text-area');

  scalePointTextareaUpdated.addEventListener("input", function (event) {
    const errorEl = scalePointWrapperUpdated.querySelector("[scale-point-error-msg]");
    let isErrorPresent = false;
    if(!errorEl) return

    let regex = /[^\w\s.,!?æøåÆØÅ]/g;
    this.value = this.value.replace(regex, '');
    let valueLength = this.value.length;
    let containsLetter = /[a-zA-ZæøåÆØÅ]/.test(this.value);

    if (!containsLetter) isErrorPresent = true;
    if(valueLength !== 10) isErrorPresent = true;
    if(valueLength === 0) isErrorPresent = false;

    if(isErrorPresent) errorEl.classList.remove('d-none');
    else errorEl.classList.add('d-none');

  });
}

const handleCartUpdate = () => {

  setTimeout(() => {
    let scalePointInfos = document.querySelectorAll('.scale-point-info');
    const scalePointTextarea = document.querySelector('input.scale-point-text-area');
    
    if (scalePointInfos) scalePointInfo();
    if (scalePointTextarea) scalePointInputOnChange();
  }, 2000);
};

document.addEventListener("cart:item-removed", handleCartUpdate);
document.addEventListener("cart:item-updated", handleCartUpdate);
document.addEventListener("cart-drawer:open", handleCartUpdate);

if(scalePointInfos) scalePointInfo();
if(scalePointTextarea) scalePointInputOnChange();